import { render, staticRenderFns } from "./PaymentGatewaySetting.vue?vue&type=template&id=09fca808&"
import script from "./PaymentGatewaySetting.vue?vue&type=script&lang=js&"
export * from "./PaymentGatewaySetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../var/www/html/film-screening-production/vuejs/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../var/www/html/film-screening-production/vuejs/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCheckbox,VDivider,VForm,VImg,VSwitch,VTextField,VTooltip})
